angular.module('impactx.MenuDirectives').directive('ixDeactivateRFQHSearch', function() {
    return {
        restrict: 'E',
        controller: 'DeactivateRFQHSearchCtrl',
        controllerAs: 'deactivateRFQHSearchCtrl',
        templateUrl: 'shared/menu/templates/deactivaterfqhsearch.tmpl.html'
    }
});